export const countDistinctTaskNotifications = (notifications) => {
    const unnotifiedGroups = notifications.reduce((a,c) => {
        if (!c?.notified) {
            if (c?.taskId === undefined || c?.taskId?.length === 0) {
                a[c?.id] = [c]
                return a
            }

            if (a[c?.taskId] === undefined) {
                a[c?.taskId] = []
            }
            a[c?.taskId].push(c)
        }
        return a
    }, {})

    return Object.keys(unnotifiedGroups).length
}